import React from 'react'
import {
  Modal,
  ModalBody,
  borderRadius,
  spacing,
  fontSize,
  fontWeight,
} from '@retailer-platform/shared-components'
import { Text } from '@instacart/ids-core'
import { colors } from '@retailer-platform/shared-components'
import { SVGIcon } from 'ic-snacks'
import styled from '@emotion/styled'

const StyledCloseButton = styled.button({
  background: 'transparent',
  display: 'block',
  height: '18px',
  cursor: 'pointer',
  transform: 'scale(0.7)',
  position: 'absolute',
  right: '10px',
  top: '10px',
})

const ModalContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  border: '1px solid rgba(91, 91, 91, 0.77)',
  borderRadius: borderRadius.X4,
})

const ModalHeader = styled.div({
  display: 'flex',
  padding: spacing.X24,
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center',
  fontSize: fontSize.X18,
  fontWeight: fontWeight.SEMIBOLD,
  color: colors.GRAYSCALE.X70,
})

const ModalFooter = styled.div({
  display: 'flex',
  padding: `${spacing.X12} ${spacing.X24}`,
  flexDirection: 'row',
  justifyContent: 'flex-end',
  width: '100%',
  alignItems: 'center',
  zIndex: 1,
})

export function TrainingModalTitle({ children }: { children: React.ReactNode }) {
  return (
    <ModalHeader style={{ borderBottomStyle: 'none' }}>
      <Text color="systemGrayscale70" typography="titleMedium">
        {children}
      </Text>
    </ModalHeader>
  )
}

export function TrainingModalContent({ children }: { children: React.ReactNode }) {
  return (
    <ModalBody>
      <div
        css={{
          lineHeight: 'normal',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between',
        }}
      >
        {children}
      </div>
    </ModalBody>
  )
}

export function TrainingModalFooter({ children }) {
  return <ModalFooter>{children}</ModalFooter>
}

export function TrainingModal({
  children,
  onClose,
  isOpen,
  imgUrl,
  maxWidth = 750,
}: {
  children: React.ReactNode
  onClose: () => void
  isOpen: boolean
  imgUrl?: string
  maxWidth?: number
}) {
  return (
    <Modal
      onRequestClose={onClose}
      isOpen={isOpen}
      maxWidth={maxWidth}
      hideCloseButton
      styleOverrides={{ content: { borderRadius: spacing.X12 } }}
    >
      <StyledCloseButton onClick={onClose} type="button">
        <SVGIcon name="x" size="standard" fill={colors.GRAYSCALE.X70} />
      </StyledCloseButton>
      <ModalContainer>
        {imgUrl ? (
          <div css={{ width: '50%' }}>
            <img
              css={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
                borderRadius: `${spacing.X12} 0 0 ${spacing.X12}`,
              }}
              src={imgUrl}
            />
          </div>
        ) : null}
        <div
          css={{
            width: imgUrl ? '50%' : '100%',
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'space-between',
            justifyContent: 'flex-start',
          }}
        >
          {children}
        </div>
      </ModalContainer>
    </Modal>
  )
}
